import React, { useState } from 'react';
import css from './promocode.module.css';
import { FormattedMessage } from 'react-intl';
import { PROMOCODE_APPLIED, verifyPromoCode } from '../CheckoutPage.duck';
import { loadInitialDataForStripePayments } from '../CheckoutPageWithPayment';
import { MdCheckCircle } from 'react-icons/md';
import { FaTimesCircle } from 'react-icons/fa';
import { Heading, PrimaryButton } from '../../../components';

export default function Promocode(props) {

  const [invalid, setInvalid] = useState(null)
  const [buttonLoading, setButtonLoading] = useState(false)

  const {
    stripeCheckoutSecret,
    promoCode,
    setPromoCode,
    pageData,
    fetchSpeculatedTransaction,
    fetchStripeCustomer,
    ispromoCodeApplied,
    listingId,
    dispatch,
    config,
    applyPromoCodeInProgress
  } = props;
  console.log("applyPromoCodeInProgress------", applyPromoCodeInProgress)

  let errorIs = null;

  switch (invalid) {
    case 'Something-wents-wrong':
      errorIs = <FormattedMessage id="OrderBreakdown.SomethingWentsWrong" />;

      break;

    case 'Promocode-is-only-valid-for-first-purchase':
      errorIs = <FormattedMessage id="OrderBreakdown.PromocodeIsOnlyValidForFirstPurchase" />;

      break;
    case 'Promocode-is-valid-for-pop-nouvelle-only':
      errorIs = <FormattedMessage id="OrderBreakdown.PromocodeValidForPopNovelleOnly" />;

      break;

    case 'Invalid-promocode':
      errorIs = <FormattedMessage id="OrderBreakdown.InvalidPromocode" />;

      break;

    case 'Promocode-already-used':
      errorIs = <FormattedMessage id="OrderBreakdown.PromocodeAlreadyUsed" />;

      break;

    case 'Promocode-not-valid-for-this-brand':
      errorIs = <FormattedMessage id="OrderBreakdown.PromocodeNotValidForThisBrand" />;

      break;

    case 'Promocode-minimum-price-not-met':
      errorIs = <FormattedMessage id="OrderBreakdown.PromocodeMinimumPriceNotMet" />;

      break;

    default:
      break
  }
  const handleOnchangePromo = e => {
    setPromoCode(e.target.value);
  };
  const handleClick = () => {
    setInvalid(null)
    setButtonLoading(true)

    dispatch({ type: PROMOCODE_APPLIED, payload: false });

    console.log('Inside handle click');
    dispatch(verifyPromoCode(promoCode, listingId))
      .then(res => {
        loadInitialDataForStripePayments({
          pageData: pageData || {},
          fetchSpeculatedTransaction,
          fetchStripeCustomer,
          config,
          promoCode: promoCode,
        });
        setButtonLoading(false)


        // setButtonLoading(false);
      })
      .catch(err => {
        if (ispromoCodeApplied) {
          loadInitialDataForStripePayments({
            pageData: pageData || {},
            fetchSpeculatedTransaction,
            fetchStripeCustomer,
            config,
            promoCode: promoCode,
          });
        }

        setInvalid(err.message)
        setButtonLoading(false)
        dispatch({ type: PROMOCODE_APPLIED, payload: false });

        console.log('err', err.message);
      });
  };


  const handleRemove = () => {
    setInvalid("true")
    setButtonLoading(true)

    dispatch({ type: PROMOCODE_APPLIED, payload: false });

    console.log('Inside remove');
    dispatch(verifyPromoCode("obais", listingId))
      .then(res => {
        console.log("res", res)
      })
      .catch(err => {
        if (ispromoCodeApplied) {
          loadInitialDataForStripePayments({
            pageData: pageData || {},
            fetchSpeculatedTransaction,
            fetchStripeCustomer,
            config,
            promoCode: "obais",
          });
        }

        setButtonLoading(false)
        dispatch({ type: PROMOCODE_APPLIED, payload: false });

        console.log('err', err.message);
      });

  }

  return (
    <div>
      <div className={css.PromoCodeContainer}>
        <Heading as="h3" rootClassName={css.heading}>
          <FormattedMessage id="StripePaymentForm.PromoCodeHeading" />
        </Heading>
        {!stripeCheckoutSecret && (
          <div className={css.couponContainer}>
            <input
              className={css.couponInput}
              placeholder="Promo code (optional)"
              type="text"
              value={promoCode}
              onChange={e => handleOnchangePromo(e)}
            />
            {!invalid && ispromoCodeApplied ?
              <PrimaryButton
                className={css.couponButton}
                inProgress={buttonLoading}

                type="button"
                onClick={() => {


                  handleRemove();
                }}
              >
                <FormattedMessage id="OrderBreakdown.PromocodeRemoveButton" />
              </PrimaryButton> : <PrimaryButton
                className={css.couponButton}
                inProgress={buttonLoading || applyPromoCodeInProgress}
                disabled={!promoCode}
                type="button"
                onClick={() => {
                  handleClick();
                }}
              >
                <FormattedMessage id="OrderBreakdown.PromocodeApplyButton" />
              </PrimaryButton>}
          </div>
        )}
        {/* <FormattedMessage id="OrderBreakdown.PromocodeInvalidMessage"/>  */}
        {invalid && (
          <div className={css.invalidPromoCode}>
            {errorIs}
            {invalid !== "true" && <FaTimesCircle size={18} />}
          </div>
        )}
        {!invalid && ispromoCodeApplied && (
          <div className={css.PromoCodeApplied}>
            <FormattedMessage id="OrderBreakdown.PromocodevalidMessage" />{' '}
            <MdCheckCircle color="green" size={18} />
          </div>
        )}
        <ul className={css.needToKnow}>
          <li>
            <FormattedMessage id="StripePaymentForm.NeedToKnowPointFirst" />
          </li>
          <li>
            <FormattedMessage id="StripePaymentForm.NeedToKnowPointSecond" />
          </li>
        </ul>
      </div>
    </div>
  );
}
